import type { ReactNode } from 'react'
import { playfair, crimson } from './fonts'

type Props = {
  children: ReactNode
}

export function DeluxeSignupFormCard({ children }: Props) {
  return (
    <div
      className="relative overflow-hidden rounded-2xl border-[3px] border-[#d4af37] p-8 md:p-12 shadow-lg"
      style={{
        background: 'linear-gradient(145deg, #ffffff 0%, #fefcf7 100%)',
        boxShadow:
          '0 10px 30px rgba(0,0,0,0.1), 0 0 0 1px rgba(212, 175, 55, 0.1)',
      }}
    >
      <div
        className="pointer-events-none absolute -top-1/2 -left-1/2 h-[200%] w-[200%]"
        style={{
          background:
            'radial-gradient(circle, rgba(212, 175, 55, 0.06) 0%, transparent 70%)',
        }}
        aria-hidden
      />
      <div className="relative z-[1] text-center">
        <h2
          className={`${playfair.className} text-3xl md:text-4xl font-semibold text-[#2c1810] mb-4`}
        >
          Get Early Access
        </h2>
        <div className="mx-auto mb-6 flex w-20 items-center justify-center">
          <div
            className="h-[3px] flex-1 rounded-full"
            style={{
              background:
                'linear-gradient(90deg, transparent, #d4af37, transparent)',
            }}
          />
        </div>
        <p
          className={`${crimson.className} text-lg leading-relaxed text-[#5a4a3a] mb-8`}
        >
          Join our exclusive deluxe edition list to receive advance notification
          when premium versions of our books become available. These limited
          editions feature enhanced binding, premium materials, and exclusive
          content not found in standard editions.
        </p>
        {children}
      </div>
    </div>
  )
}
